import React, { useState,useEffect } from 'react';
import styled from 'styled-components';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Container = styled.div`
  padding: 30px;
  background-color: #f8f9fb;
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color: #293495;
`;

const FilterCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px #e0e0e0;
  margin-bottom: 20px;
`;

const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const InputGroup = styled.div`
  flex: 1;
  min-width: 220px;
  display: flex;
  flex-direction: column;

  label {
    font-weight: 600;
    margin-bottom: 4px;
  }

  input,
  select {
    border: none;
    border-bottom: 1px solid #2b3497;
    padding: 8px;
    outline: none;
    background: transparent;
  }
`;

const ButtonGroup = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 10px;

  button {
    padding: 8px 16px;
    border: none;
    font-weight: bold;
    border-radius: 4px;
    cursor: pointer;

     &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .apply {
    background-color: #293495;
    color: #fff;
  }

  .clear {
    background-color: red;
    color: #fff;
  }
`;

const ZeroState = styled.div`
  text-align: center;
  margin-top: 100px;
  color: #7a7a7a;

  h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
  }
`;

const TableWrapper = styled.div`
  margin-top: 30px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px;
  background-color: #e6e6e6;
  color: #000;
`;

const Td = styled.td`
  padding: 12px;
  border-top: 1px solid #ddd;
`;

const Tag = styled.span`
  background-color: ${(props) =>
    props.status === 'Open'
      ? '#d2f3d5'
      : props.status === 'Closed'
        ? '#e1e1e1'
        : '#d0e7ff'};
  color: #000;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin-right: 5px;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #293495;
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1e2a7a;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #293495;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const StyledDatePicker = styled(DatePicker)`
  width: 250px;
  padding: 8px;
`;


const sampleData = [
  {
    date: 'Jul 17, 2025',
    txnId: 'TXN-258717-1D8B2E',
    from: 'Tuty_IN',
    to: 'Chennai_IN',
    movement: 'inward',
    status: 'Open',
    materialCount: 1,
    handler: 'Ramesh',
    approver: 'Sabarish',
  },
  {
    date: 'Jun 16, 2025',
    txnId: 'TXN-258616-BA5929',
    from: 'Fidrox',
    to: 'Manjunath',
    movement: 'inward',
    status: 'Open',
    materialCount: 3,
    handler: 'Ramesh',
    approver: 'Manjunath',
  },
  // Add more rows if needed
];

const MaterialTransactions = () => {
  const [filters, setFilters] = useState({
    txnId: '',
    approvedBy: '',
    handler: '',
    movementType: '',
    dateRange: [null, null], // [startDate, endDate]
  });

  const [filtersApplied, setFiltersApplied] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [filteredData, setFilteredData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (range) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: range,
    }));
  };


  // const applyFilters = () => {
  //   setFiltersApplied(true);
  //   setCurrentPage(1); // reset to first page
  // };
  const applyFilters = async () => {
    const { txnId, movementType, handler, approvedBy, dateRange } = filters;

    const [start, end] = dateRange;
    const dateFrom = start ? start.toISOString().split('T')[0] : '';
    const dateTo = end ? end.toISOString().split('T')[0] : '';

    const params = {};
    if (txnId) params.TransactionId = txnId;
    if (movementType) params.MovementType = movementType;
    if (handler) params.HandledBy = handler;
    if (approvedBy) params.ApprovedBy = approvedBy;
    if (dateFrom) params.DateFrom = dateFrom;
    if (dateTo) params.DateTo = dateTo;
    params.limit = rowsPerPage;
    params.offset = (currentPage - 1) * rowsPerPage;

    try {
      const response = await axios.get('MaterialTransaction', { params });
      setFilteredData(response.data.results);
      setTotalCount(response.data.count);
      setFiltersApplied(true);
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  useEffect(() => {
    if (filtersApplied) {
      applyFilters(); // Refetch when page/limit changes
    }
  }, [currentPage, rowsPerPage]);





  const clearFilters = () => {
    setFilters({
      txnId: '',
      movementType: '',
      handler: '',
      approvedBy: '',
      dateRange: [null, null],
    });

    setFiltersApplied(false);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData;
const totalPages = Math.ceil(totalCount / rowsPerPage);
  const navigate = useNavigate();

  const isAnyFilterFilled = () => {
    const { txnId, movementType, handler, approvedBy, dateRange } = filters;

    return (
      txnId.trim() !== '' ||
      movementType !== '' ||
      handler.trim() !== '' ||
      approvedBy.trim() !== '' ||
      (dateRange[0] !== null && dateRange[1] !== null)
    );
  };



  return (
    <Container>
      <Header>
        <Heading>Material Management</Heading>
      </Header>

      <FilterCard>
        <FormRow>
          <InputGroup>
            <label>Transaction ID</label>
            <input
              type="text"
              name="txnId"
              placeholder="TXN-..."
              value={filters.txnId}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <label>Movement Type</label>
            <select name="movementType" value={filters.movementType} onChange={handleChange}>
              <option value="">Select movement type</option>
              <option value="inward">inward</option>
              <option value="outward">outward</option>
            </select>
          </InputGroup>

          <InputGroup>
            <label>Handled By</label>
            <input
              type="text"
              name="handler"
              placeholder="Handler name"
              value={filters.handler}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <label>Approved By</label>
            <input
              type="text"
              name="approvedBy"
              placeholder="Approver name"
              value={filters.approvedBy}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <label>Date Range</label>
            <StyledDatePicker
              selectsRange
              startDate={filters.dateRange[0]}
              endDate={filters.dateRange[1]}
              onChange={handleDateChange}
              isClearable
              placeholderText="Select date range"
              dateFormat="MMM d, yyyy"
            />
          </InputGroup>

        </FormRow>

        <ButtonGroup>
          <button className="apply" disabled={!isAnyFilterFilled()} onClick={applyFilters}>
            Apply Filters
          </button>
          <button className="clear" disabled={!isAnyFilterFilled()} onClick={clearFilters}>
            Clear Filters
          </button>
        </ButtonGroup>
      </FilterCard>

      {!filtersApplied && (
        <ZeroState>
          <h3>Apply filters to view transactions</h3>
          <p>Use the filters above to search for specific transactions</p>
        </ZeroState>
      )}

      {filtersApplied && (
        <>
          <TableWrapper>
            <h3>Transactions ({totalCount})</h3>
            <Table>
              <thead>
                <tr>
                  <Th>Date</Th>
                  <Th>Transaction ID</Th>
                  <Th>From Address</Th>
                  <Th>To Address</Th>
                  <Th>Movement</Th>
                  <Th>Material Count</Th>
                  <Th>Handled By</Th>
                  <Th>Approved By</Th>
                  <Th>Actions</Th>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((row, index) => (
                  <tr key={index}>
                    <Td>{new Date(row.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</Td>
                    <Td>{row.transactionId}</Td>
                    <Td>{row.fromAddress}</Td>
                    <Td>{row.toAddress}</Td>
                    <Td>
                      <Tag>{row.movementType}</Tag>
                      <Tag status={row.isClosed ? 'Closed' : 'Open'}>
                        {row.isClosed ? 'Closed' : 'Open'}
                      </Tag>
                    </Td>
                    <Td>{row.materialsCount}</Td>
                    <Td>{row.handledBy}</Td>
                    <Td>{row.approvedBy}</Td>
                    <Td>
                      <ActionButtons>
                        <FaEdit color="#293495" style={{ cursor: 'pointer' }} />
                        <FaTrash color="red" style={{ cursor: 'pointer' }} />
                      </ActionButtons>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrapper>

          {sampleData.length > 0 && (
            <PaginationContainer>
              <PaginationButton onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
                Prev
              </PaginationButton>
              <span>Page {currentPage} of {totalPages}</span>
              <PaginationButton onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
              <DropdownSelect value={rowsPerPage} onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
              </DropdownSelect>
            </PaginationContainer>
          )}
        </>
      )}

      <FloatingButton title="Create" onClick={() => navigate('/layout/add-material')}>
        <FaPlus />
      </FloatingButton>
    </Container>
  );
};

export default MaterialTransactions;
